export function trackEvent(name: string, props?: Record<string, any>) {
  const n = String(name || '').trim()
  if (!n) return
  const data = { ...(props || {}), event: n, ts: Date.now() }
  try {
    window.dispatchEvent(new CustomEvent('nw:track', { detail: data }))
  } catch {}
  try {
    const gtag = (window as any)?.gtag
    if (typeof gtag === 'function') gtag('event', n, props || {})
  } catch {}
}

